module.exports = __webpack_public_path__ + "img/4de341a035cca229f4b48079339a6a0a.svg";